export const ListQueryKey = 'rollDiceRecords';
export const DetailQueryKey = 'rollDiceRecord';

export const Urls = {
  selectUrl: '/rollDiceRecord/list',
  updateUrl: '/rollDiceRecord/update',
  deleteUrl: '/rollDiceRecord/delete',
  createUrl: '/rollDiceRecord/create',
  detailUrl: '/rollDiceRecord/info',
};
